import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile, openFileInFrame, openFileInNewTab } from "../../../helpers/utils/FileUtils";

export const associationApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAssociationApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/getAllAssociations?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['association'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchAssociationFeeApi: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/getAllAssociationsFee?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["association"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAssociationById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAssociationDocuments: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-document-list/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['associationsDocuments'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAssociationHistory: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-logs/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['associationAssignmentLogs'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSubdivisionByAssociationId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-sub-divisions-by-association-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['associationsSubdivision', "subDivisionById"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateAssociationDetailApi: build.mutation({
            query: ({ requestBody, associationId }) => {
                return {
                    url: `/ajax/update/association/${associationId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Associations Detail");
            },
        }),

        updateAssociationFeeDetailApi: build.mutation({
            query: ({ requestBody, associationId }) => {
                return {
                    url: `/ajax/update/association-fee/${associationId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['association','associationFeeById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Associations Fee Detail");
            },
        }),
        createAssociationFeeDetailApi: build.mutation({
            query: ({ requestBody }) => {
                return {
                    url: `/ajax/create/associationFee`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['association'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Associations Detail");
            },
        }),

        createAssociationDetailApi: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/association`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Associations Detail");
            },
        }),

        createAssociationNoteApi: build.mutation({
            query: ({ associationId, requestBody }) => {
                return {
                    url: `/ajax/create-association-note/${associationId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Associations Notes");
            },
        }),

        deleteAssociationFeeById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-association-fee-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['association'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Association fee");
            },
        }),

        deleteAssociationNotesById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/deleteAssociationNote/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Notes");
            },
        }),
        deleteAssociationsById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-association-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['associationById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Associations");
            },
        }),

        getAssociationFeeById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-fee-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['associationFeeById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAssociationData: build.query({
            query: (query) => {
                return {
                    url: `/export/association?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("associations"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
       



        viewAssociationsFile: build.query({
            query: ({ fileId, isDownload, isOpenInFrame }) => {
                return {
                    url: `/ajax/download-association-file/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: any) => {
                        const blob = await response.blob();
                        if (!isOpenInFrame) {
                            const contentDisposition = response.headers.get('Content-Disposition');
                            const filename = contentDisposition
                                ? contentDisposition.split('filename=')[1]
                                : `file_${fileId}.pdf`;

                            isDownload ? downloadFile(blob, filename) : openFileInNewTab(blob)
                        } else {
                            openFileInNewTab(blob);
                        }
                        return { success: true };
                    },
                };

            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        deleteBulkAssociations: build.mutation({
            query: (associationIds) => {
                let list = { associationIds: associationIds };
                let paramData = serialize(list)
                return {
                    url: `/ajax/delete/bulk/association?${paramData}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['association'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});


export const {
    useGetAssociationByIdQuery,
    useSearchAssociationApiQuery,
    useLazyExportAssociationDataQuery,
    useGetAssociationDocumentsQuery,
    useGetAssociationHistoryQuery,
    useGetSubdivisionByAssociationIdQuery,
    useSearchAssociationFeeApiQuery,
    useUpdateAssociationDetailApiMutation,
    useDeleteAssociationFeeByIdMutation,
    useGetAssociationFeeByIdQuery,
    useUpdateAssociationFeeDetailApiMutation,
    useCreateAssociationFeeDetailApiMutation,
    useCreateAssociationDetailApiMutation,
    useLazyViewAssociationsFileQuery,
    useCreateAssociationNoteApiMutation,
    useDeleteAssociationNotesByIdMutation,
    useDeleteAssociationsByIdMutation,
    useDeleteBulkAssociationsMutation,
} = associationApi;